<template>
  <ax-dialog 
    ref="dialog"
    mode="listitem"
    title="Rename Group" 
    linkText="Rename Group" 
    icon="mdi-form-textbox" 
    size="small" 
    @submitted="onSubmit"
    :disabled="disabled"
  >
    <template slot="content">
      <v-card-text>
        <v-text-field v-model="group.name" label="Name of Group"></v-text-field>
      </v-card-text>
    </template>
    <template slot="submit_text"> Save </template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgRenameGroup",
  props: {
    group: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    AxDialog
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.group)
    }
  }
}
</script>